module.exports = __webpack_public_path__ + "static/img/MaskGroup.e4d338d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MaskGroup.png
// module id = jKLd
// module chunks = 13